import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class DownloadIcon extends BaseIcon {
  getChildren = () => [ <path fill={ this.getColor() }
                              d='M0.995,15.01L1,12l2,0.008v1H13.007V11.986l1.973,0.022v3H0.995Zm7.054-3.09L4.01,6.979H7V1H9V6.979h3.011Z'/> ]
  getViewBox = () => '0 0 16 16'
}
